document.addEventListener("DOMContentLoaded", function () {
  const productKey = document.body.dataset.productHandle;

  // ✅ Restore settings panel state
  if (sessionStorage.getItem("keepSettingsOpen") === "true") {
    document
      .querySelector(".js-cd-panel-main")
      ?.classList.add("cd-panel--is-visible");
    document.body.style.overflow = "hidden";
    sessionStorage.removeItem("keepSettingsOpen");

    if (window.Notyf) {
      const notyf = new Notyf();
      notyf.success({
        message: "Settings have been reset.",
        duration: 4000,
        dismissible: true,
      });
    }
  }

  // ✅ Panel open/close logic
  const panelTriggers = document.getElementsByClassName("js-cd-panel-trigger");
  if (panelTriggers.length > 0) {
    for (let i = 0; i < panelTriggers.length; i++) {
      (function (i) {
        const panelClass =
          "js-cd-panel-" + panelTriggers[i].getAttribute("data-panel");
        const panel = document.getElementsByClassName(panelClass)[0];

        panelTriggers[i].addEventListener("click", function (event) {
          event.preventDefault();
          panel.classList.add("cd-panel--is-visible");
          document.body.style.overflow = "hidden";
        });

        panel.addEventListener("click", function (event) {
          if (
            event.target.classList.contains("js-cd-close") ||
            event.target.classList.contains(panelClass)
          ) {
            event.preventDefault();
            panel.classList.remove("cd-panel--is-visible");
            document.body.style.overflow = "auto";
          }
        });
      })(i);
    }
  }

  // ✅ Load saved settings
  const savedModel = localStorage.getItem(`spec_model_${productKey}`);
  const savedColor = localStorage.getItem("spec_color");
  const savedLogo = localStorage.getItem("spec_logo");

  const modelInput = document.querySelector("input[name='model']");
  const colorInput = document.querySelector("input[name='color']");
  const logoInput = document.querySelector("input[name='logo']");

  if (savedModel) {
    document.querySelector(".model").textContent = savedModel;
    document.title = savedModel;
    modelInput.value = savedModel;
  }

  if (savedColor) {
    applyColor(savedColor);
    colorInput.value = savedColor;
  }

  if (savedLogo) {
    document.querySelectorAll("#logo, .logo img").forEach((el) => {
      el.src = savedLogo;
    });
  }

  // ✅ Model input (per-product)
  modelInput.addEventListener("input", function () {
    const value = this.value.trim() || this.placeholder;
    document.querySelector(".model").textContent = value;
    document.title = value;
    localStorage.setItem(`spec_model_${productKey}`, value);
  });

  // ✅ Color picker (global)
  colorInput.addEventListener("input", function () {
    const color = this.value;
    applyColor(color);
    localStorage.setItem("spec_color", color);
  });

  function applyColor(color) {
    document.querySelectorAll(".model, .features > h2").forEach((el) => {
      el.style.color = color;
    });
    document.querySelectorAll(".spec-table").forEach((el) => {
      el.style.backgroundColor = color;
      el.style.borderColor = color;
    });
    document.querySelectorAll(".spec .footer").forEach((el) => {
      el.style.backgroundColor = color;
    });
  }

  // ✅ Logo upload (global)
  logoInput.addEventListener("change", function () {
    const file = this.files[0];
    if (!file) return;

    // ✅ Validate file type
    const allowedTypes = ["image/png", "image/jpeg", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      alert("Please upload a PNG, JPEG, or GIF image.");
      this.value = ""; // clear file input
      return;
    }

    // ✅ Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10 MB
    if (file.size > maxSize) {
      alert("Logo file must be 10MB or smaller.");
      this.value = "";
      return;
    }

    // ✅ Safe to convert and use
    const reader = new FileReader();
    reader.onload = function (e) {
      const base64 = e.target.result;
      document.querySelectorAll("#logo, .logo img").forEach((el) => {
        el.src = base64;
      });
      localStorage.setItem("spec_logo", base64);
    };
    reader.readAsDataURL(file);
  });

  // ✅ Reset button
  const resetButton = document.querySelector(".reset");
  if (resetButton) {
    resetButton.addEventListener("click", function () {
      localStorage.removeItem(`spec_model_${productKey}`);
      localStorage.removeItem("spec_color");
      localStorage.removeItem("spec_logo");
      sessionStorage.setItem("keepSettingsOpen", "true");
      location.reload();
    });
  }

  // ✅ PDF Download
  const createBtn = document.querySelector(".create");
  if (createBtn) {
    createBtn.addEventListener("click", function () {
      const div = document.querySelector(".spec");
      window.scrollTo(0, 0);

      html2canvas(div, {
        scale: 3,
        dpi: 300,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
      }).then(function (canvas) {
        const img = canvas.toDataURL("image/jpeg", 1.0);
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF("p", "in", [11, 8.5]);

        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();

        doc.addImage(img, "JPEG", 0, 0, width, height);

        // ✅ Use model as file name, sanitized
        const modelName =
          document.querySelector(".model")?.textContent?.trim() || "specsheet";
        const safeFileName = modelName.replace(/[^a-z0-9_\-]/gi, "_");
        doc.save(safeFileName + ".pdf");

        if (window.Notyf) {
          const notyf = new Notyf();
          notyf.success({
            message: "PDF Downloaded",
            duration: 4000,
            dismissible: true,
          });
        }
      });
    });
  }
});
